<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Expenses</b-navbar-brand>
        </b-navbar>

        <banner-component
          :allModuleIdBanner="
            this.$sessionsStorage.get('port_allModuleId')
              ? this.$sessionsStorage.get('port_allModuleId')
              : ''
          "
          :jobSeriesBanner="
            this.$sessionsStorage.get('port_JOBSERIES')
              ? this.$sessionsStorage.get('port_JOBSERIES')
              : ''
          "
          :bannerClientName="
            assignmentData[0].clientName ? assignmentData[0].clientName : ''
          "
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <div class="row">
                <div class="col-md-6 box-body mb-2 mr-1">
                  <h5>
                    <b-badge variant="info">Assignment Details</b-badge>
                  </h5>
                  <b-table
                    show-empty
                    stacked="md"
                    :items="assignmentData"
                    :fields="assignmentfields"
                    :per-page="assignmentperPage"
                    :sort-by.sync="assignmentsortBy"
                    :sort-desc.sync="assignmentsortDesc"
                    :sort-direction="assignmentsortDirection"
                  >
                    <template slot="allModuleId" slot-scope="row0">
                      <span>{{
                        row0.index + 1 + (assignmentcurrentPage - 1) * assignmentperPage
                      }}</span>
                    </template>
                  </b-table>
                </div>
                <div class="col-md-5 box-body mb-2">
                  <h5>
                    <b-badge variant="info">Expense Document Details</b-badge>
                  </h5>

                  <b-table
                    show-empty
                    stacked="md"
                    :items="ExpenseData"
                    :fields="Expensefields"
                    :per-page="ExpenseperPage"
                    :sort-by.sync="ExpensesortBy"
                    :sort-desc.sync="ExpensesortDesc"
                    :sort-direction="ExpensesortDirection"
                  >
                    <template slot="exp_id" slot-scope="row0">
                      <span>{{
                        row0.index + 1 + (ExpensecurrentPage - 1) * ExpenseperPage
                      }}</span>
                    </template>
                    <template slot="exp_doc_link" slot-scope="row1">
                      <h6>
                        <a
                          style="color: blue"
                          v-if="row1.item.exp_doc_link"
                          href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${assignmentData[0].Job_Series.replaceAll('/', '_')}/${row1.item.exp_doc_link.replaceAll('/', '_')}`)"
                          ><b
                            ><u>{{ "Doc " + parseInt(row1.index + 1) }}</u></b
                          ></a
                        >
                      </h6>
                    </template>
                  </b-table>
                </div>
              </div>

              <b-button
                id="show-btn"
                size="sm"
                variant="outline-primary"
                @click="addPortExpenseArray"
              >
                Add Expenses <i class="fa fa-plus" aria-hidden="true"></i
              ></b-button>
              <b-card class="mt-2" v-for="(itm, idx) in linePortExpenseArray" :key="idx">
                <div class="d-flex align-items-center" v-if="idx != 0">
                  <b-button
                    class="ml-auto"
                    id="show-btn"
                    size="sm"
                    variant="danger"
                    @click="removeInvArry(idx)"
                  >
                    Remove Expenses <i class="fa fa-plus" aria-hidden="true"></i
                  ></b-button>
                </div>

                <b-row align-v="start">
                  <b-col sm="3"
                    ><label>Invoice Type <span class="error">*</span> </label>
                     <model-list-select
                      multiple="true"
                      :isDisabled="accounts == true && role != 'Admin' ? true : false"
                      :list="$store.getters['commonDropdownMaster/getAllPortExpenseDDList']"
                      v-model="itm.invType"
                      option-value="documentTypeId"
                      option-text="documentName"
                      placeholder="Select Invoice Type"
                    >
                    </model-list-select>
                    <!-- <model-list-select
                      multiple="true"
                      :isDisabled="accounts == true && role != 'Admin' ? true : false"
                      :list="invoiceTypeList"
                      v-model="itm.invType"
                      option-value="value"
                      option-text="text"
                      placeholder="Select Invoice Type"
                    >
                    </model-list-select> -->
                    <span class="error" v-if="itm.invType_err ? true : false">{{
                      itm.invType_err
                    }}</span>
                  </b-col>
                  <b-col sm="3"
                    ><label>Invoice Amount <span class="error">*</span></label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      type="number"
                      name="InvoiceAmount"
                      id="InvoiceAmount"
                      v-model="itm.invAmount"
                    ></b-form-input>
                    <span class="error" v-if="itm.invAmount_err">{{
                      itm.invAmount_err
                    }}</span>
                    <span class="error" v-if="itm.createdBy">{{
                      "Created By : " + itm.createdBy + " Date Time " + itm.created_at
                    }}</span>
                  </b-col>
                  <b-col sm="3"
                    ><label>Remarks</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invRemarks"
                    >
                    </b-form-textarea>
                  </b-col>
                  <b-col sm="3">
                    <label>Invoice Documents <span class="error"></span></label>
                    <Single-Upload
                      :index="idx"
                      :multiple="false"
                      :documentName="'Expense_Port_Multiple_Doc-'"
                      :otherDocName="'Expense_Port_Multiple_Doc-'"
                      :folderName="'Expense'"
                      :accept="'*'"
                      v-model="itm.invSlineUpload"
                      :state="Boolean(itm.invSlineUpload)"
                      :assign_no="assignmentData[0].Job_Series"
                      :fileAllModuleId="$sessionsStorage.get('port_allModuleId')"
                    />
                    <span class="error" v-if="itm.invSlineUpload_err">{{
                      itm.invSlineUpload_err
                    }}</span
                    ><br />
                    <a
                      v-if="assign_no_series && itm.invSlineUpload"
                      href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${doc_path}/${itm.invSlineUpload}`)"
                      >--View Document</a
                    >
                  </b-col>
                </b-row>
              </b-card>

              <md-layout md-gutter class="gutr center">
                <md-layout md-flex="100">
                  <b-button
                    v-if="linePortExpenseArray.length > 0"
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addPortExpenseDetail"
                    >Save & Submit
                  </b-button>

                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="popMailAfter"
        ></md-dialog-confirm>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";

import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import SingleUpload from "../common/singleUpload.vue";
import AccountService from "../../services/AccountService.js";
import CommonDDService from "../../services/CommonDDService.js";

export default {
  beforeMount() {
    this.$store.dispatch(
      "commonDropdownMaster/setAllPortExpenseDDList",
      JSON.stringify({
        type: "Expense Port",
        isDocumentActive: 1,
        itemCode:"All_Document_Type_List",
      })
    );
    if (
      this.$sessionsStorage.get("port_allModuleId") != undefined &&
      this.$sessionsStorage.get("port_JOBSERIES") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/allModule/portExpenses");
      if (this.$sessionsStorage.get("port_allModuleId")) {
        this.getSinglePortExpense();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    port_JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getSinglePortExpense();
      },
      deep: true,
    },
  },

  data() {
    return {
      assignmenttotalRows: 1000000000000000,
      assignmentcurrentPage: 1,
      assignmentperPage: 25,
      assignmentpageOptions: [20, 50, 100],
      assignmentsortBy: null,
      assignmentsortDesc: false,
      assignmentsortDirection: "asc",
      assignmentfields: [
        {
          key: "allModuleId",
          mainkey: "allModuleId",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "Job_Series",
          mainkey: "Job_Series",
          label: "Job No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "JobDate",
          mainkey: "JobDate",
          label: "Job Date",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "POD",
          mainkey: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
      ],

      ExpensetotalRows: 1000000000000000,
      ExpensecurrentPage: 1,
      ExpenseperPage: 25,
      ExpensepageOptions: [20, 50, 100],
      ExpensesortBy: null,
      ExpensesortDesc: false,
      ExpensesortDirection: "asc",
      Expensefields: [
        {
          key: "exp_id",
          mainkey: "exp_id",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "exp_type",
          mainkey: "exp_type",
          label: "Expense Type",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "exp_amount",
          mainkey: "exp_amount",
          label: "Expense Amount",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "exp_remarks",
          mainkey: "exp_remarks",
          label: "Expense Remark",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "invDate",
          mainkey: "invDate",
          label: "Expense Date",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "exp_doc_link",
          mainkey: "exp_doc_link",
          label: "View",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
      ],

      assignmentData: [],
      ExpenseData: [],
      singleUpload: [],
      docRemark: "",
      docRemark_err: "",
      docArray: [
        {
          documentName: "",
          documentLink: "",
          docRemarks: "",
          addedFromMain: "5",
          allModuleId: this.$sessionsStorage.get("port_allModuleId"),
          JOBType: this.$sessionsStorage.get("port_JOBType"),
        },
      ],
      files: [],
      files_err: "",
      err_flag: false,
      assign_no_series: this.$sessionsStorage.get("port_JOBSERIES"),
      allModuleId: this.$sessionsStorage.get("port_allModuleId"),
      doc_path: this.$sessionsStorage.get("port_JOBSERIES").replaceAll("/", "_"),
      JOBType: this.$sessionsStorage.get("port_JOBType"),
      syncFlag: false,
      invnoErrFlag: false,
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      invBlDraftUpload: "",
      componentKey: 0,
      revisedInvoiceDetails: [],
      selectedInvoice: [],
      items: [],
      lastSelectItem: {},

      invoiceTypeList: [
        {
          value: "Vendor Expenses",
          text: "Vendor Expenses",
        },
        {
          value: "Fuel Expenses",
          text: "Fuel Expenses",
        },
        {
          value: "Transportation Outsource",
          text: "Transportation Outsource",
        },
        {
          value: "CFS Expenses",
          text: "CFS Expenses",
        },
        {
          value: "ICD Expenses",
          text: "ICD Expenses",
        },
        {
          value: "Railout Expenses",
          text: "Railout Expenses",
        },
        {
          value: "Others Expenses",
          text: "Others Expenses",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      PortExpenseDetail: {
        moduleType: "",
        revisedMail: "0",
        dueDate: "",
        invoiceAmount: "",
        sobDate: "",
        doc_path_series: "",
        allModuleId: "",
        paymentDone: "",
        userId: "",
        slineInvoice: "",
        exp_id: "",

        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
      },

      errorINVExecution: [],
      arrayINVExecutionError: [
        "Invoice Type Field Required",
        "Invoice No Field Required",
        "Invoice Amount Field Required",
        "Currency Field Required",
        "Invoice Documents Field Required",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      permissionStatus: true,
      PortExpenseDetailArray: [],
      showMoreSB: false,

      role: this.$sessionsStorage.get("designation"),
      linePortExpenseArray: [],

      validatePortExpense: true,
      fileIndex: "0",
      singleUpload: "",
    };
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.singleUpload = file;
    });
    eventBus.$on("fileuploadedindex", (fileindex) => {
      console.log("fileuploadedindex=>", fileindex);
      this.fileIndex = fileindex;
      this.linePortExpenseArray[fileindex].invSlineUpload = this.singleUpload;
    });
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    Multiselect,
    MultiFileUploader,
    SingleUpload,
  },
  computed: {
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        !this.PortExpenseDetail.exp_id
        ? true
        : false;
    },
  },
  methods: {
    reset() {
      this.items = []; // reset
    },

    addPortExpenseArray() {
      let obj = {
        invId: "",
        exp_id: "",
        allModuleId: this.$sessionsStorage.get("port_allModuleId"),
        JOBType: this.$sessionsStorage.get("port_JOBType"),
        invType: "",
        invAmount: "",
        invCurrency: "INR",
        invSlineUpload: "",
        otherDocName: "",
        createdBy: "",
        updatedBy: "",
        created_at: "",
        invRemarks: "",

        invType_err: "",
        invAmount_err: "",
        invCurrency_err: "",
        invSlineUpload_err: "",
        invRemarks_err: "",
      };
      this.linePortExpenseArray.push(obj);

      console.log(this.linePortExpenseArray.length);
    },

    removeInvArry(index) {
      this.linePortExpenseArray.splice(index, 1);
    },
    goBack() {
      window.history.go(-1);
    },

    validatePortExpenseDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.linePortExpenseArray;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].invType == "") {
          this.linePortExpenseArray[j]["invType_err"] = "Invoice Type Field is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.linePortExpenseArray[j]["invType_err"] = "";
          validate_new = true;
        }

        if (MainARR[j].invAmount == "") {
          this.linePortExpenseArray[j]["invAmount_err"] =
            "Invoice Amount Field is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.linePortExpenseArray[j]["invAmount_err"] = "";
          validate_new = true;
        }

        if (MainARR[j].invCurrency == "") {
          this.linePortExpenseArray[j]["invCurrency_err"] =
            "Invoice Currency Field is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.linePortExpenseArray[j]["invCurrency_err"] = "";
          validate_new = true;
        }

        // if (MainARR[j].invSlineUpload == "") {
        //   this.linePortExpenseArray[j]["invSlineUpload_err"] =
        //     "Invoice Document Field is Required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.linePortExpenseArray[j]["invSlineUpload_err"] = "";
        //   validate_new = true;
        // }
      }
      console.log("this.linePortExpenseArray=>", this.linePortExpenseArray);
      if (errCount > 0) {
        this.validatePortExpense = false;
      }
      if (validate_new == false) {
        this.validatePortExpense = false;
      } else {
        this.validatePortExpense = true;
      }
    },
    addPortExpenseDetail() {
      let array = this.linePortExpenseArray;
      this.validatePortExpenseDetail();

      if (this.validatePortExpense == false) {
        this.alert.content = "PLEASE ENTER ALL * DETAILS .";
        this.$refs["addPop"].open();
        return false;
      }
      this.PortExpenseDetail["doc_path_series"] = this.doc_path;
      this.PortExpenseDetail["uploadArray"] = [];

      this.PortExpenseDetail.salesExeuctionNo = this.$sessionsStorage.get(
        "port_JOBSERIES"
      );
      this.PortExpenseDetail.allModuleId = this.$sessionsStorage.get("port_allModuleId");
      this.PortExpenseDetail.JobType = this.$sessionsStorage.get("port_JOBType");

      this.PortExpenseDetail.invoiceDetails = this.linePortExpenseArray;
      this.PortExpenseDetail.TypeofAdd = "PortExpense Master Add";
      console.log("After => ", this.PortExpenseDetail);
      // return false

      let payload = {
        itemCode: "add_portExpense",
        PortExpenseDetail: this.PortExpenseDetail,
      };
      if (this.validatePortExpense != false) {
        this.isLoading = true;
        AccountService.getAllAccountList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.exp_id != "" && data.exp_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on addPortExpenseForm Error: ", error);
          });
      }
    },

    getSinglePortExpense() {
      this.isLoading = true;
      let payload = {
        allModuleId: this.$sessionsStorage.get("port_allModuleId"),
        JOBType: this.$sessionsStorage.get("port_JOBType"),
        exp_id: this.$sessionsStorage.get("exp_id"),
        itemCode: "Single_portExpense",
      };

      AccountService.getAllAccountList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.singlePortExpense.length > 0) {
              this.ExpenseData = data.singlePortExpense;
            }
            if (data.assignmentData.length > 0) {
              this.assignmentData = data.assignmentData;
            }

            if (data.singlePortExpense.length > 0) {
              Object.keys(this.linePortExpenseArray).map((x) => {
                this.linePortExpenseArray[x] = data.singlePortExpense[0][x] || "";
              });
              this.PortExpenseDetailArray = data.singlePortExpense;

              let i = 0;
              data.singlePortExpense.forEach((element) => {
                data.AssUploadExpenseData.forEach((element2) => {
                  if (element.exp_doc_link == element2.documentLink) {
                    element.otherDocName = element2.otherDocName;
                  }
                });

                var date2 = new Date(element.invDate);
                var result2 =
                  "" +
                  date2.getFullYear() +
                  (date2.getMonth() + 1 > 9 ? "-" : "-0") +
                  (date2.getMonth() + 1) +
                  (date2.getDate() > 9 ? "-" : "-0") +
                  date2.getDate();
                var invDate = "";
                if (result2 == "1970-01-01") {
                  var invDate = "";
                } else {
                  var invDate = result2;
                }
                this.PortExpenseDetail.exp_id = element.exp_id || "";
                element["invDate"] = invDate || "";
                element["exp_id"] = element.exp_id || "";
                element["allModuleId"] = element.allModuleId || "";
                element["invType"] = element.exp_type || "";
                element["invAmount"] = element.exp_amount || "";
                element["invCurrency"] = element.exp_Currency || "";
                element["invSlineUpload"] = element.exp_doc_link || "";
                element["invRemarks"] = element.exp_remarks || "";
                element["createdBy"] = element.createdBy || "";
                element["updatedBy"] = element.updatedBy || "";
                element["created_at"] = element.created_at || "";
                this.linePortExpenseArray.push(element);
                i++;
              });
            }
            console.log(" Single Port Expense response=>", this.linePortExpenseArray);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Port Expense Error: ", error);
        });
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ExpensesPort.vue?693a98f3